import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { nodeCookie } from "@catchoftheday/utilities";
import { CONSTRUCTOR_CLIENT_ID, CONSTRUCTOR_SESSION_ID } from "../../consts";
export var headerInitialProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appContext) {
    var req, cookies, cnstrClientId, cnstrSessionId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            req = appContext.ctx.req;
            cookies = req ? nodeCookie.parse(req.headers.cookie || "") : {};
            cnstrClientId = cookies[CONSTRUCTOR_CLIENT_ID] || "1";
            cnstrSessionId = Number(cookies[CONSTRUCTOR_SESSION_ID]) || 1;
            return _context.abrupt("return", {
              headerCookies: {
                cnstrClientId: cnstrClientId,
                cnstrSessionId: cnstrSessionId
              }
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function headerInitialProps(_x) {
    return _ref.apply(this, arguments);
  };
}();